import React from 'react';

const Footer = () => {
  const version = process.env.REACT_APP_VERSION;

  return (
    <footer className="footer">
      <div className="footer-content">
        <span>Version: {version}</span>
      </div>
    </footer>
  );
};

export default Footer;
